import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0eda20d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "table-head" };
const _hoisted_3 = { class: "paginate-container" };
import { ref } from 'vue';
import { useStore } from '@/store/store';
import { useStakingHistory } from '@/logics/staking_history';
import Table from '@/components/organisms/main/staking/history/Table.vue';
import { useMessage } from '@/const/messages';
import CheckBoxSetDisable from '@/materials/atoms/CheckBoxSetDisable.vue';
import Select from '@/materials/atoms/Select.vue';
import VPagination from '@hennge/vue3-pagination';
import Loading from '@/materials/molecules/Loading.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null,
        selectedSymbol: null,
        isAuth: { type: Boolean }
    },
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const store = useStore();
            const { STAKING_HISTORY, format } = useMessage();
            const MAX_DISPLAY_LIMIT = 10;
            const OFFSET = 1;
            const stakingPlanId = ref(0);
            const isChecked = ref(false);
            const pagesCount = ref(0);
            const count = ref(0);
            const isLoading = ref(false);
            const nowPage = ref(1);
            const { getStakingHistory, getStakingHistoryCount } = useStakingHistory();
            const history = props.isAuth ? (([__temp, __restore] = _withAsyncContext(() => getStakingHistory(props.userInfo.id, stakingPlanId.value, isChecked.value, OFFSET, MAX_DISPLAY_LIMIT).catch((err) => {
                console.error(err);
                return {
                    stakeFundsList: [],
                    currencies: [],
                };
            }))),
                __temp = yield __temp,
                __restore(),
                __temp) :
                {
                    stakeFundsList: [],
                    currencies: [],
                };
            count.value = props.isAuth ? (([__temp, __restore] = _withAsyncContext(() => getStakingHistoryCount(props.userInfo.id, stakingPlanId.value, isChecked.value).catch((err) => {
                console.error(err);
                return 0;
            }))),
                __temp = yield __temp,
                __restore(),
                __temp) : 0;
            pagesCount.value = Math.ceil(count.value / MAX_DISPLAY_LIMIT);
            const historyTemp = ref(history.stakeFundsList);
            const currenciesTemp = ref(history.currencies);
            history.currencies.unshift({ id: history.currencies.length, symbol: 'all' });
            const selectionList = history.currencies.map((d) => ({ title: d.symbol, value: d.symbol }));
            const selectedSymbol = ref(props.selectedSymbol);
            const onSelectField = (symbol) => {
                selectedSymbol.value = symbol;
                const temp = history.currencies.find((e) => e.symbol === selectedSymbol.value && e.symbol !== 'all');
                stakingPlanId.value = temp !== undefined ? temp.id : 0;
                nowPage.value = 1;
                sortData();
            };
            const isCheckField = (isCheck) => {
                isChecked.value = isCheck;
                nowPage.value = 1;
                sortData();
            };
            const sortData = () => __awaiter(this, void 0, void 0, function* () {
                if (isLoading.value) {
                    return;
                }
                historyTemp.value = [];
                isLoading.value = true;
                count.value = yield getStakingHistoryCount(props.userInfo.id, stakingPlanId.value, isChecked.value).catch((err) => {
                    console.error(err);
                    return 0;
                });
                pagesCount.value = Math.ceil(count.value / MAX_DISPLAY_LIMIT);
                yield getStakingHistory(props.userInfo.id, stakingPlanId.value, isChecked.value, MAX_DISPLAY_LIMIT * (nowPage.value - 1) + 1, MAX_DISPLAY_LIMIT)
                    .then((response) => {
                    isLoading.value = false;
                    historyTemp.value = response.stakeFundsList;
                })
                    .catch((err) => {
                    console.error(err);
                    return {
                        stakeFundsList: [],
                        currencies: [],
                    };
                });
                // historyTemp.value = temp.stakeFundsList;
            });
            const paging = (page) => __awaiter(this, void 0, void 0, function* () {
                historyTemp.value = [];
                nowPage.value = page;
                isLoading.value = true;
                count.value = yield getStakingHistoryCount(props.userInfo.id, stakingPlanId.value, isChecked.value).catch((err) => {
                    console.error(err);
                    return 0;
                });
                pagesCount.value = Math.ceil(count.value / MAX_DISPLAY_LIMIT);
                yield getStakingHistory(props.userInfo.id, stakingPlanId.value, isChecked.value, MAX_DISPLAY_LIMIT * (nowPage.value - 1) + 1, MAX_DISPLAY_LIMIT)
                    .then((response) => {
                    isLoading.value = false;
                    historyTemp.value = response.stakeFundsList;
                })
                    .catch((err) => {
                    console.error(err);
                    return {
                        stakeFundsList: [],
                        currencies: [],
                    };
                });
                // historyTemp.value = temp.stakeFundsList;
            });
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h1", null, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).PAGE)), 1),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                            _createVNode(Select, {
                                model: 'all',
                                selectionList: _unref(selectionList),
                                width: 150,
                                class: "custom-select",
                                onChange: onSelectField,
                                disabled: isLoading.value
                            }, null, 8, ["selectionList", "disabled"])
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["checkbox-container", {
                                    'add-space': _unref(store).state.userSettings.language === 'Japanese',
                                }])
                        }, [
                            _createVNode(CheckBoxSetDisable, {
                                class: _normalizeClass(_ctx.$style.historycheckbox),
                                isInitCheck: false,
                                label: '',
                                id: '',
                                onChange: isCheckField,
                                isDisabled: isLoading.value || !props.isAuth
                            }, null, 8, ["class", "isDisabled"]),
                            _createElementVNode("span", {
                                class: _normalizeClass({
                                    'add-space': _unref(store).state.userSettings.language === 'Japanese',
                                })
                            }, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).SHOW)), 3)
                        ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(VPagination), {
                            modelValue: nowPage.value,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((nowPage).value = $event)),
                                paging
                            ],
                            pages: pagesCount.value,
                            "range-size": 1,
                            "active-color": "#DCEDFF",
                            class: "pagenation"
                        }, null, 8, ["modelValue", "pages"])
                    ]),
                    (!isLoading.value)
                        ? (_openBlock(), _createBlock(Table, {
                            key: 0,
                            columnName: currenciesTemp.value,
                            data: historyTemp.value,
                            isClickable: false
                        }, null, 8, ["columnName", "data"]))
                        : _createCommentVNode("", true),
                    (isLoading.value)
                        ? (_openBlock(), _createBlock(Loading, {
                            key: 1,
                            mode: "simple"
                        }))
                        : _createCommentVNode("", true)
                ]));
            };
        });
    }
});
